import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
// import SwaggerUI, { presets } from 'swagger-ui';

// [MJA] using this version crashes with the Docker build
// import 'swagger-ui/dist/swagger-ui.css';
import './swagger-ui.css';

class ApiComponent extends React.PureComponent {
  static propTypes = {
    prefix: PropTypes.string.isRequired,
    configuration: PropTypes.shape({
      jsonConfig: PropTypes.shape({
        doc: PropTypes.shape({ homeButton: PropTypes.bool }),
      }),
    }),
    routeService: PropTypes.shape({
      getHomeURL: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    url: PropTypes.string,
    id: PropTypes.string,
  }

  static defaultProps = {
    configuration: {},
    url: undefined,
    id: 'swagger_ui',
  }

  constructor(props) {
    super(props);

    const cfg = props.configuration.jsonConfig.doc;
    this.homeButton = cfg && cfg.homeButton;
    this.handleClose = this.handleClose.bind(this);
  }

  async componentDidMount() {
      const { SwaggerUIBundle } = await import(/* webpackChunkName: "/swaggerui" */ 'swagger-ui-dist');
      SwaggerUIBundle({
        url: this.props.url || `${this.props.prefix}/swagger.json`,
        dom_id: `#${this.props.id}`,
        presets: [
          SwaggerUIBundle.presets.apis,
          SwaggerUIBundle.SwaggerUIStandalonePreset
        ],
      });
    }

  handleClose() {
    const { routeService, history } = this.props;
    history.push(routeService.getHomeURL(), { referrer: this.props.location });
  }

  render() {
      return (
        <React.Fragment>
          <div id={this.props.id} style={{ position: 'relative' }} />
          {this.homeButton && (
            <div style={{ position: 'absolute', top: '12px', right: '18px' }} className="tuc-home-button">
              <IconButton aria-label="Delete" size="medium" onClick={this.handleClose}>
                <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  <path fill="none" d="M0 0h24v24H0z" />
                </svg>
              </IconButton>
            </div>
          )}
        </React.Fragment>
      );
  }
}

export default ApiComponent;
